export default __webpack_public_path__ + "static/Trustlessbank_logo-3887c66e8411fe755f9a9d11006f11bb.png";